import React from "react";
import { Container, Row, Col } from "react-bootstrap";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <Container fluid className="footer">
      <Row>
        <Col md="4" className="footer-copywright">
          <p></p>
        </Col>
        <Col md="4" className="footer-copywright">
          <h3>Shared Success Foundation ({year})</h3>
        </Col>
        <Col md="4" className="footer-body">
          <p></p>
        </Col>
      </Row>
    </Container>
  );
}

export default Footer;
